import objwrap from "./helper/objwrap.js";

export default objwrap("color");
